<template>
  <!-- AnomalyBanner — SPEC-CHINA-LOT-BATCH-TRACEABILITY-001 REQ-FE-TRC-006 -->
  <div v-if="anomalies && anomalies.length > 0" class="anomaly-banner-container">
    <a-alert
      v-for="(item, idx) in anomalies"
      :key="idx"
      :type="severityToType(item.severity)"
      :message="anomalyMessage(item)"
      show-icon
      style="margin-bottom: 8px;"
    />
  </div>
</template>

<script>
export default {
  name: 'AnomalyBanner',
  props: {
    anomalies: { type: Array, default: () => [] },
  },
  methods: {
    severityToType(severity) {
      if (severity === 'error') return 'error';
      if (severity === 'warning') return 'warning';
      return 'info';
    },
    anomalyMessage(item) {
      const typeKeyMap = {
        not_found: 'lotTrace_anomaly_not_found',
        missing_ecount: 'lotTrace_anomaly_missing_ecount',
        missing_dealer_inventory: 'lotTrace_anomaly_missing_dealer_inventory',
        missing_dealer_sales: 'lotTrace_anomaly_missing_dealer_sales',
        timeline_violation: 'lotTrace_anomaly_timeline_violation',
        depleted: 'lotTrace_anomaly_depleted',
        partial_response: 'lotTrace_anomaly_partial_response',
      };
      if (item.type === 'missing_dealer_purchase') {
        const key = item.severity === 'info'
          ? 'lotTrace_anomaly_missing_dealer_purchase_info'
          : 'lotTrace_anomaly_missing_dealer_purchase_warning';
        return this.$t(key);
      }
      const key = typeKeyMap[item.type];
      return key ? this.$t(key) : (item.message || item.type);
    },
  },
};
</script>
